// extracted by mini-css-extract-plugin
export default {"box":"App_box__69Fv4"};